<template lang="pug">
  .activity-success
    .top
      img(src="../../../public/images/member/redconfirmtop.png")
    .header
      img(src="../../../public/images/member/redconfirmheader.png")
    .pay-bottom
      .tip 开通即可免费领20元话费+视频会员！
      .price
        //- .price-mian
        //-   span.label 会员费：
        //-   span.price-val
        //-     span.unit ¥
        //-     | 19
        .price-desc 会员可随时关闭
      .submit-button
        el-button(@click="toPay") 立即开通
</template>

<script>
export default {
  data() {
    return {
      channel: 'TUIA',
      form: {
        mobile: '',
        goodsCode: 'WXPAPAY210226002'
      },
      channelOrderNo: ''
    }
  },
  mounted() {
    let _orderCacheStr = localStorage.getItem('language-member-order')
    if (_orderCacheStr) {
      let _orderCache = JSON.parse(_orderCacheStr);
      this.form.mobile = _orderCache.mobile
      this.channelOrderNo = _orderCache.oid
      this.reqNo = localStorage.getItem('language-member-req-no')
      if (this.reqNo) {
        localStorage.removeItem('language-member-req-no')
        this.confirmPay()
      }
    } else {
      this.$router.push({
        name: 'lanRed'
      })
    }
  },
  methods: {
    toPay() {
      let _formData = {
        mobile: this.form.mobile,
        goodsCode: this.form.goodsCode,
        channel: this.channel,
        channelOrderNo: this.channelOrderNo
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在提交...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.OrderService
        .createActPayOrder(_formData)
        .then(res => {
          if (res.data.success) {
            this.reqNo = res.data.sub_data.req_no
            localStorage.setItem('language-member-req-no', res.data.sub_data.req_no)
            localStorage.setItem('language-member-mobile', this.form.mobile)
            this.$loading({
              lock: true,
              text: '正在确认中，请稍后...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            location.href = res.data.sub_data.pay_url
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
            if (res.data.result_code == '1') {
              location.href = 'https://mp.weixin.qq.com/s?__biz=MzU0NjkwNjU1Mw==&mid=100000052&idx=1&sn=b6ce9ce71f15c9c5312a1f41e3c644f4&chksm=7b57c9e24c2040f43493d171c6a086b084726925abc4b0b01adfdae2e15d40cc7408a4b1f6b1#rd'
            }
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    confirmPay() {
      let _loading = this.$loading({
        lock: true,
        text: '正在确认签约状态...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.OrderService
        .queryPayOrder({
          reqNo: this.reqNo,
          mobile: this.form.mobile
        })
        .then(res => {
          if (res.data.success) {
            if (res.data.sub_data.trade_state.toUpperCase() === 'SUCCESS') {
              this.$message({
                type: 'success',
                message: '签约成功，正在前往Language会员公众号'
              })
              location.href = 'https://mp.weixin.qq.com/s?__biz=MzU0NjkwNjU1Mw==&mid=100000052&idx=1&sn=b6ce9ce71f15c9c5312a1f41e3c644f4&chksm=7b57c9e24c2040f43493d171c6a086b084726925abc4b0b01adfdae2e15d40cc7408a4b1f6b1#rd'
            } else {
              this.$message({
                type: 'warning',
                message: res.data.sub_data.trade_state_desc
              })
            }
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '查询失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    }
  }
}
</script>

<style lang="less" scoped>
.activity-success{
  background-color: #f3f3f3;
  min-height: 100vh;
  img{
    width: 100%;
  }
}
.info{
  font-size: 1.1rem;
  text-align: center;
  padding-top: 3rem;
  .banner{
    width: 64px;
    height: 64px;
  }
}
.color-red{
  color: Red;
}
.font-big{
  font-weight: bold;
}
.ad{
  margin-top: 1rem;
  text-align: center;
  padding: 0 1rem;
  .bl{
    width: 100%;
  }
}
.btn-copy{
  color: #fff;
  background-color: red;
  border: 0;
  margin-top: .5rem;
}
.point{
  margin: .5rem 0;
  border: 2px dashed #d3d3d3;
  padding: .2rem;
}
.page-module{
  width: 92%;
  margin: 0 auto;
  border-radius: 4px;
}
.pay-bottom{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  background-color: #fff;
  >div{
    flex: 1;
    height: 3.4rem;
    line-height: 3.4rem;
    &.price{
      font-size: 1rem;
      .label{
        margin-left: .5rem;
      }
      .price-mian{
        line-height: 1.5rem;
      }
      .price-desc{
        line-height: 3.5rem;
        font-size: 1rem;
        font-weight: bold;
        color: #bd8326;
        margin-left: .6rem;
      }
      .price-val{
        font-size: 1.4rem;
        color: #f04346;
        .unit{
          font-size: 1rem;
        }
      }
      del{
        font-size: .8rem;
        color: #a3a3a3;
      }
    }
    &.submit-button{
      text-align: right;
      button{
        border: 0;
        background-color: #f04346;
        color: #fff;
        font-size: 1.2rem;
        width: 100%;
        height: 3.4rem;
        border-radius: 0;
      }
    }
  }
  .tip{
    background: linear-gradient(to bottom,#ff632a,#ff3143);
    color: #fff;
    font-size: .8rem;
    position: absolute;
    top: -1.9rem;
    left: 3rem;
    border-radius: .3rem;
    height: 1rem;
    line-height: 1rem;
    padding: .2rem .4rem;
    &:after{
      content: '';
      position: absolute;
      left: 1rem;
      bottom: 0;
      width: 0;
      height: 0;
      border: .3rem solid transparent;
      border-top: .6rem solid #ff3143;
      transform: translateY(100%) skew(-30deg);
    }
  }
}
.pay{
  background-color: #fff;
  padding: .3rem 0;
  .title{
    padding: .3rem .5rem;
    font-size: 1rem;
    color: #525252;
  }
  .pay-item{
    display: flex;
    padding: .3rem;
    >div{
      flex: 1;
    }
    .pay-name{
      font-size: 1rem;
      img{
        width: 1.3rem;
        height: 1.3rem;
        vertical-align: top;
        margin: 0 .3rem;
      }
    }
    .pay-select{
      text-align: right;
      input{
        margin-right: 1rem;
      }
    }
  }
}
.header{
  margin: 0 auto;
  margin-top: -5rem;
  width: 90%;
  img{
    border-radius: 24px;
    box-shadow: 0 3px 6px #a3a3a3;
  }
}
</style>